var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-col",
    _vm._b(
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.widget.options.hidden,
            expression: "!widget.options.hidden",
          },
        ],
        key: _vm.widget.id,
        staticClass: "grid-cell",
        class: [_vm.customClass],
        style: _vm.colHeightStyle,
      },
      "el-col",
      _vm.layoutProps,
      false
    ),
    [
      !!_vm.widget.widgetList && _vm.widget.widgetList.length > 0
        ? [
            _vm._l(_vm.widget.widgetList, function (subWidget, swIdx) {
              return [
                "container" === subWidget.category
                  ? [
                      _c(_vm.getComponentByContainer(subWidget), {
                        key: swIdx,
                        tag: "component",
                        attrs: {
                          widget: subWidget,
                          "parent-list": _vm.widget.widgetList,
                          "index-of-parent-list": swIdx,
                          "parent-widget": _vm.widget,
                        },
                        scopedSlots: _vm._u(
                          [
                            _vm._l(
                              Object.keys(_vm.$scopedSlots),
                              function (slot) {
                                return {
                                  key: slot,
                                  fn: function (scope) {
                                    return [_vm._t(slot, null, null, scope)]
                                  },
                                }
                              }
                            ),
                          ],
                          null,
                          true
                        ),
                      }),
                    ]
                  : [
                      _c(subWidget.type + "-widget", {
                        key: swIdx,
                        tag: "component",
                        attrs: {
                          field: subWidget,
                          designer: null,
                          "parent-list": _vm.widget.widgetList,
                          "index-of-parent-list": swIdx,
                          "parent-widget": _vm.widget,
                        },
                        scopedSlots: _vm._u(
                          [
                            _vm._l(
                              Object.keys(_vm.$scopedSlots),
                              function (slot) {
                                return {
                                  key: slot,
                                  fn: function (scope) {
                                    return [_vm._t(slot, null, null, scope)]
                                  },
                                }
                              }
                            ),
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
              ]
            }),
          ]
        : [
            _c("el-col", [
              _c("div", { staticClass: "blank-cell" }, [
                _c("span", { staticClass: "invisible-content" }, [
                  _vm._v(_vm._s(_vm.i18nt("render.hint.blankCellContent"))),
                ]),
              ]),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }